export const USER_LOADING = "USER_LOADING";
export const USER_LOADED = "USER_LOADED";
export const SET_CURRENT_USER = "SET_CURRENT_USER";
